/* istanbul ignore file */
import React from 'react';
import loadable from '@loadable/component';

import { SplashScreen } from '@components/SplashScreen';

const Login = loadable(() => import('@features/Login'), {
  resolveComponent: components => components.Login,
  fallback: <SplashScreen />,
});

const CguValidation = loadable(() => import('@features/CguValidation'), {
  resolveComponent: components => components.CguValidation,
  fallback: <SplashScreen />,
});

const Account = loadable(() => import('@features/Account'), {
  resolveComponent: components => components.Account,
  fallback: <SplashScreen />,
});

const Home = loadable(() => import('@features/Home'), {
  resolveComponent: components => components.Home,
  fallback: <SplashScreen />,
});

const Racecards = loadable(() => import('@features/Racecards'), {
  resolveComponent: components => components.Racecards,
  fallback: <SplashScreen />,
});

const Meeting = loadable(() => import('@features/Meeting'), {
  resolveComponent: components => components.Meeting,
  fallback: <SplashScreen />,
});

const MeetingsCalendar = loadable(() => import('@features/MeetingsCalendar'), {
  resolveComponent: components => components.MeetingsCalendar,
  fallback: <SplashScreen />,
});

const QuintePlus = loadable(() => import('@features/QuintePlus'), {
  resolveComponent: components => components.QuintePlus,
  fallback: <SplashScreen />,
});

const Race = loadable(() => import('@features/Race'), {
  resolveComponent: components => components.Race,
  fallback: <SplashScreen />,
});

const NonRunners = loadable(() => import('@features/NonRunners'), {
  resolveComponent: components => components.NonRunners,
  fallback: <SplashScreen />,
});

const RacingEvents = loadable(() => import('@features/RacingEvents'), {
  resolveComponent: components => components.RacingEvents,
  fallback: <SplashScreen />,
});

const Publications = loadable(() => import('@features/Publications'), {
  resolveComponent: components => components.Publications,
  fallback: <SplashScreen />,
});

const Proposal = loadable(() => import('@features/Proposal'), {
  resolveComponent: components => components.Proposal,
  fallback: <SplashScreen />,
});

const NotFound = loadable(() => import('@features/NotFound'), {
  resolveComponent: components => components.NotFound,
  fallback: <SplashScreen />,
});

export {
  Login,
  CguValidation,
  Account,
  Home,
  Racecards,
  Meeting,
  MeetingsCalendar,
  QuintePlus,
  Race,
  NonRunners,
  RacingEvents,
  Publications,
  Proposal,
  NotFound,
};
